import { API_CONFIG } from '../config/api';
import { getCurrentTimestamp } from '../utils/dateUtils';

const API_URL = API_CONFIG.API_URL;


// Check if an order has a linked Send Out appointment and if it's paid
export const checkSendOutStatus = async (orderNo) => {
  const response = await fetch(`${API_URL}/api/orders/${orderNo}/send-out-check`);
  if (!response.ok) throw new Error('Failed to check Send Out status');
  return response.json();
};

// Auto-Complete Order Functions
export const autoCompleteOrder = async (orderNo, executedBy, deliveryMethod = null) => {
  try {
    if (!orderNo || !executedBy) {
      throw new Error('Order number and executed by are required');
    }

    console.log('🚀 Auto-completing order:', orderNo, 'by:', executedBy);

    const response = await fetch(`${API_URL}/api/orders/${orderNo}/auto-complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderNo: orderNo,
        executedBy: executedBy,
        executedAt: getCurrentTimestamp(),
        deliveryMethod: deliveryMethod
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Auto-complete error:', errorData);
      throw new Error(errorData.message || `Auto-complete failed with status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('✅ Auto-complete successful:', data);
    return data;
  } catch (error) {
    console.error('Error auto-completing order:', error);
    throw error;
  }
};

// Bulk auto-complete multiple orders
export const bulkAutoCompleteOrders = async (orderNos, executedBy) => {
  try {
    if (!orderNos || !executedBy) {
      throw new Error('Order numbers and executed by are required');
    }

    console.log(`🚀 Bulk auto-completing ${Array.isArray(orderNos) ? orderNos.length : 'multiple'} orders by:`, executedBy);

    const response = await fetch(`${API_URL}/api/orders/bulk-auto-complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderNos: orderNos,
        executedBy: executedBy
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Bulk auto-complete error:', errorData);
      throw new Error(errorData.message || `Bulk auto-complete failed with status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Bulk auto-complete successful:', data);
    return data;
  } catch (error) {
    console.error('Error bulk auto-completing orders:', error);
    throw error;
  }
};

// Undo auto-complete for an order
export const undoAutoCompleteOrder = async (orderNo, executedBy) => {
  try {
    const response = await fetch(`${API_URL}/api/orders/${orderNo}/undo-auto-complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        executedBy: executedBy,
        executedAt: getCurrentTimestamp()
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Undo operation failed');
    }
    
    return data;
  } catch (error) {
    console.error('Error undoing auto-complete:', error);
    throw error;
  }
};

// Check if an order can be undone
export const checkCanUndoAutoComplete = async (orderNo) => {
  try {
    const response = await fetch(`${API_URL}/api/orders/${orderNo}/can-undo-auto-complete`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error checking undo status:', error);
    // Return safe defaults on error
    return {
      canUndo: false,
      orderNo: orderNo,
      lastCompleted: null
    };
  }
};
